import {
  columnOrderingFeature,
  columnPinningFeature,
  columnResizingFeature,
  columnSizingFeature,
  columnVisibilityFeature,
  type RowData,
  rowSortingFeature,
  type Table,
  tableFeatures,
} from "@tanstack/react-table";

export const features = tableFeatures({
  rowSortingFeature,
  columnVisibilityFeature,
  columnOrderingFeature,
  columnPinningFeature,
  columnSizingFeature,
  columnResizingFeature,
});

export type DataTableInstance<R extends RowData> = Table<typeof features, R>;
